/**
 * KBVisibilityService
 * CRUD for the KBVisibility lookup table (Public / Unlisted / Restricted).
 * Mirrors CourseVisibilityService.
 * Route: api/kb-visibilities
 */
import { BaseService } from '../base/BaseService';
export class KBVisibilityService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? KBVisibilityService.DEFAULT_SERVICE_PATH,
            basePath: KBVisibilityService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAll() {
        const response = await this.getAllRaw();
        return response.data ?? [];
    }
    getAllRaw() {
        return this.http.get(this.buildUrl(''));
    }
    async getById(id) {
        const response = await this.getByIdRaw(id);
        return response.data ?? null;
    }
    getByIdRaw(id) {
        return this.http.get(this.buildUrl(this.getEndpoint('getById', `${id}`)));
    }
    async create(item) {
        const response = await this.createRaw(item);
        return response.data ?? null;
    }
    createRaw(item) {
        return this.http.post(this.buildUrl(''), item);
    }
    async update(id, item) {
        const response = await this.updateRaw(id, item);
        return response.data ?? null;
    }
    updateRaw(id, item) {
        return this.http.put(this.buildUrl(this.getEndpoint('update', `${id}`)), item);
    }
    async delete(id) {
        const response = await this.deleteRaw(id);
        return response.success;
    }
    deleteRaw(id) {
        return this.http.delete(this.buildUrl(this.getEndpoint('delete', `${id}`)));
    }
}
KBVisibilityService.DEFAULT_SERVICE_PATH = 'resources';
KBVisibilityService.BASE_PATH = 'api/kb-visibilities';
//# sourceMappingURL=KBVisibilityService.js.map